import React, { useState, useRef } from 'react';
import {
  TextField,
  InputAdornment,
  Popper,
  Paper,
  ClickAwayListener,
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Picker from '@emoji-mart/react';
import data from '@emoji-mart/data';
import { useTheme } from '@mui/material/styles';

export default function EmojiDropdown({
  value,
  onChange,
  label = 'Emoji',
}) {
  // We track open/close in state
  const [open, setOpen] = useState(false);

  // This ref anchors the popper to the entire container
  const anchorRef = useRef(null);

  const handleToggle = (event) => {
    // If already open, close; otherwise open.
    setOpen((prev) => !prev);
  };

  const handleClickAway = () => {
    setOpen(false);
  };

  const handleEmojiSelect = (emoji) => {
    onChange(emoji.native);
    setOpen(false);
  };

  const muiTheme = useTheme();
const isDarkMode = muiTheme.palette.mode === 'dark';

  return (
    <>
      {/* 
        We wrap the TextField in a container <div> with a ref.
        The popper will anchor to this <div>, no matter what part is clicked.
      */}
      <div ref={anchorRef} style={{ position: 'relative' }}>
        <TextField
          label={label}
          value={value || ''}
          fullWidth
          inputProps={{
            style: { cursor: 'pointer' },
          }}
          InputProps={{
            readOnly: true,
            // If there's no value, show placeholder
            ...(!value && { placeholder: 'Choose an emoji...' }),
            endAdornment: (
              <InputAdornment position="end" sx={{ cursor: 'pointer' }}>
                <ArrowDropDownIcon
                  onClick={(e) => {
                    // Prevent the text field's onClick from firing again
                    e.stopPropagation();
                    handleToggle(e);
                  }}
                  sx={{
                    transition: 'transform 0.2s ease',
                    transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
                    cursor: 'pointer',
                    // Remove hover circle
                    '&:hover': { backgroundColor: 'transparent' },
                  }}
                />
              </InputAdornment>
            ),
          }}
          InputLabelProps={{
            shrink: !!value || open,
          }}
          // Clicking anywhere on the TextField toggles the popper, 
          // always anchored to the same container <div>.
          sx={{ cursor: 'pointer' }}
          onClick={handleToggle}
        />
      </div>

      {/* 
        The Popper always anchors to anchorRef.current 
        => the same container, so it's consistently placed. 
      */}
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        placement="bottom-start"
        disablePortal={false} // ensures it floats above the MUI dialog
        style={{ zIndex: 9999 }}
      >
        <ClickAwayListener onClickAway={handleClickAway}>
          <Paper sx={{ p: 1, zIndex: 9999 }}>
            <Picker
              data={data}
              theme={isDarkMode ? 'dark' : 'light'}
              onEmojiSelect={handleEmojiSelect}
              style={{ width: 300, height: 300 }}
            />
          </Paper>
        </ClickAwayListener>
      </Popper>
    </>
  );
}
